<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'redirect',
})
</script>
<!--
 * @Author: guoxioaoxiao guoxiaoxiao01@longfor.com
 * @Date: 2025-02-11 14:57:33
 * @LastEditors: guoxioaoxiao guoxiaoxiao01@longfor.com
 * @LastEditTime: 2025-03-10 10:45:01
 * @FilePath: /qd-c4-yunjing-web/src/layouts/redirect/index.vue
 * @Description: 这是默认设置,请设置`customMade`,
-->
<template>
  <div></div>
</template>
<script lang="ts" setup name="redirect">
  import { onMounted } from 'vue';
  import { useRoute, useRouter } from 'vue-router';

  const router = useRouter();
  const replaceAll = (str: string, substr: string) => {
    if (!str) {
      return str;
    }
    return str.replace(new RegExp(substr, 'gm'), '');
  };
  onMounted(() => {
    const { fullPath } = useRoute();
    router.replace(`${replaceAll(fullPath, '/redirect')}`);
  });
</script>
